var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
//!!!! WARNING !!!!!!!!
//This is an auto generated file.
//Changes to this code will be lost if the code is regenerated.
//Generated by: TsAppClientApiPrinter
//Contact #dev-ui-platform-support in case of issues
import { GeneratedApiClient } from "../ApiClient";
import { HttpMethod, AuthStrategy } from "../HttpClient";
/* tslint:disable:no-namespace */
export var FleetOwnerPortalService;
(function (FleetOwnerPortalService) {
    var ApiClientClass = /** @class */ (function (_super) {
        __extends(ApiClientClass, _super);
        function ApiClientClass() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.getDriversForLiveMap = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDriversForLiveMap",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.getDrivers = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDrivers",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.getDriver = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDriver",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.updateDriver = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/updateDriver",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.getDriverEngagementDataDateRange = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDriverEngagementData/dateRange",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.getDriverEngagementDownload = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDriverEngagementDownload",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.driverToggleCash = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/driver/toggleCash",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.driverGetBlocksHistory = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/driver/getBlocksHistory",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.driverDocumentsGetDriverDocumentsSet = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/driverDocuments/getDriverDocumentsSet",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.driverDocumentsUploadDriverDocument = function (body, files, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/driverDocuments/uploadDriverDocument",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body,
                            files: files
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.driverDocumentsIsDriverDocumentUploadEnabled = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/driverDocuments/isDriverDocumentUploadEnabled",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.addDriverRegistration = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/addDriverRegistration",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.getDriverRegistrations = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDriverRegistrations",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.getDriverRegistrationStatus = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDriverRegistrationStatus",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.driverToggleDeactivation = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/driver/toggleDeactivation",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.driverRewardsGetLevelsAndBenefitsDetails = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/driverRewards/getLevelsAndBenefitsDetails",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.driverRewardsGetRewardsDetails = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/driverRewards/getRewardsDetails",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarController.ts)} */
            _this.vehicleModelsList = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicleModels/list",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarController.ts)} */
            _this.getCars = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCars",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarController.ts)} */
            _this.getCar = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCar",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarController.ts)} */
            _this.getCarsPaginated = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCarsPaginated",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarController.ts)} */
            _this.getVehicles = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getVehicles",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarController.ts)} */
            _this.getCarsDownload = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCarsDownload",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarDocumentController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarDocumentController.ts)} */
            _this.uploadCarDocument = function (body, files, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/uploadCarDocument",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body,
                            files: files
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarDocumentController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarDocumentController.ts)} */
            _this.getCarDocumentsSet = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCarDocumentsSet",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarDocumentController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarDocumentController.ts)} */
            _this.getCarDocumentUrl = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCarDocumentUrl",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarDocumentController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarDocumentController.ts)} */
            _this.deleteCarDocument = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/deleteCarDocument",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CarController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CarController.ts)} */
            _this.vehicleToggleDeactivation = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/vehicle/toggleDeactivation",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyController.ts)} */
            _this.getCompanyDetails = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCompanyDetails",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyController.ts)} */
            _this.updateCompanyDetails = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/updateCompanyDetails",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyController.ts)} */
            _this.addTaxIdentification = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/addTaxIdentification",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyController.ts)} */
            _this.updateTaxIdentification = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/updateTaxIdentification",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyController.ts)} */
            _this.deleteTaxIdentificationDetails = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/deleteTaxIdentificationDetails",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyController.ts)} */
            _this.getCompanyActiveBlocks = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCompanyActiveBlocks",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetIncentivesController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetIncentivesController.ts)} */
            _this.fleetIncentivesGetCampaignList = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/fleetIncentives/getCampaignList",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetIncentivesController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetIncentivesController.ts)} */
            _this.fleetIncentivesGetCampaignDetails = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/fleetIncentives/getCampaignDetails",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetIncentivesController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetIncentivesController.ts)} */
            _this.fleetIncentivesGetCampaignParticipants = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/fleetIncentives/getCampaignParticipants",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetIncentivesController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetIncentivesController.ts)} */
            _this.fleetIncentivesGetCampaignParticipantsCSV = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/fleetIncentives/getCampaignParticipantsCSV",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetIncentivesController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetIncentivesController.ts)} */
            _this.fleetIncentivesGetCampaignListCSV = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/fleetIncentives/getCampaignListCSV",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyController.ts)} */
            _this.getFleetBalanceDetails = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getFleetBalanceDetails",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyController.ts)} */
            _this.getFleetBalanceDetailsPdf = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getFleetBalanceDetailsPdf",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyController.ts)} */
            _this.getFleetBalanceSummary = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getFleetBalanceSummary",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerNotificationSettingsController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetOwnerNotificationSettingsController.ts)} */
            _this.getFleetOwnerConsents = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getFleetOwnerConsents",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetOwnerNotificationSettingsController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetOwnerNotificationSettingsController.ts)} */
            _this.changeFleetOwnerConsents = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/changeFleetOwnerConsents",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyDocumentController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyDocumentController.ts)} */
            _this.uploadCompanyDocument = function (body, files, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/uploadCompanyDocument",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body,
                            files: files
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [CompanyDocumentController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/CompanyDocumentController.ts)} */
            _this.getCompanyDocumentsSet = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCompanyDocumentsSet",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.getFeatures = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getFeatures",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.getVehicleBrandingSignupUrl = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getVehicleBrandingSignupUrl",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.getDriverFormOfWorkConfig = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getDriverFormOfWorkConfig",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.getSendDriverOfflineFeatures = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getSendDriverOfflineFeatures",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.getSupportWidgetUrl = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getSupportWidgetUrl",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.hasUnreadSupportCases = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/hasUnreadSupportCases",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.isPopupViewed = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/isPopupViewed",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.getMqttConnectionInfo = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getMqttConnectionInfo",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.getUnreadCasesWithLastMessage = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getUnreadCasesWithLastMessage",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
            _this.getSupportCaseWidgetUrl = function (opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getSupportCaseWidgetUrl",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            }
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.sendWaitingDriverOffline = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/sendWaitingDriverOffline",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [FleetMetricsController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetMetricsController.ts)} */
            _this.getCompanyPerformance = function (query, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/getCompanyPerformance",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.GET,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            query: query
                        }, opts)];
                });
            }); };
            /** Generated from: {@link [DriverController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/DriverController.ts)} */
            _this.driverUpdateCategoriesConstraints = function (body, opts) { return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    return [2 /*return*/, this.httpClient.sendRequest({
                            path: "/fleetOwnerPortal/driver/updateCategoriesConstraints",
                            service_id: "fleet-owner-portal",
                            subdomain: "fleetownerportal",
                            http_method: HttpMethod.POST,
                            meta: {
                                auth: { enabled: true, strategy: AuthStrategy.MULTI },
                                sharding: { enabled: false },
                                virtualPaths: { enabled: (_b = (_a = this.apiClientOptions) === null || _a === void 0 ? void 0 : _a.virtualPathsEnabled) !== null && _b !== void 0 ? _b : true }
                            },
                            body: body
                        }, opts)];
                });
            }); };
            return _this;
        }
        return ApiClientClass;
    }(GeneratedApiClient));
    // Split class actual prototype and type
    FleetOwnerPortalService.ApiClient = ApiClientClass;
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var Accessibility;
    (function (Accessibility) {
        Accessibility["VISIBLE"] = "visible";
        Accessibility["HIDDEN"] = "hidden";
    })(Accessibility = FleetOwnerPortalService.Accessibility || (FleetOwnerPortalService.Accessibility = {}));
    /** Generated from: {@link [CampaignTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/CampaignTypes.ts)} */
    var BlockItemType;
    (function (BlockItemType) {
        BlockItemType["TEXT"] = "text";
        BlockItemType["PERIOD"] = "period";
        BlockItemType["LOCATION"] = "location";
    })(BlockItemType = FleetOwnerPortalService.BlockItemType || (FleetOwnerPortalService.BlockItemType = {}));
    /** Generated from: {@link [CompanyDetailsService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/service/CompanyDetailsService.ts)} */
    var BlockResolutionAction;
    (function (BlockResolutionAction) {
        BlockResolutionAction["NONE"] = "none";
        BlockResolutionAction["DOCUMENTS"] = "documents";
        BlockResolutionAction["TAX_INFO"] = "tax_info";
        BlockResolutionAction["BALANCE"] = "balance";
    })(BlockResolutionAction = FleetOwnerPortalService.BlockResolutionAction || (FleetOwnerPortalService.BlockResolutionAction = {}));
    /** Generated from: {@link [CampaignTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/CampaignTypes.ts)} */
    var BonusIconVariant;
    (function (BonusIconVariant) {
        BonusIconVariant["GREEN"] = "green";
        BonusIconVariant["GREY"] = "grey";
    })(BonusIconVariant = FleetOwnerPortalService.BonusIconVariant || (FleetOwnerPortalService.BonusIconVariant = {}));
    /** Generated from: {@link [BrandHelper.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/util/brand/BrandHelper.ts)} */
    var BrandEnum;
    (function (BrandEnum) {
        BrandEnum["BOLT"] = "bolt";
        BrandEnum["HOPP"] = "hopp";
    })(BrandEnum = FleetOwnerPortalService.BrandEnum || (FleetOwnerPortalService.BrandEnum = {}));
    /** Generated from: {@link [CampaignTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/CampaignTypes.ts)} */
    var CampaignStatus;
    (function (CampaignStatus) {
        CampaignStatus["UPCOMING"] = "upcoming";
        CampaignStatus["ACTIVE"] = "active";
        CampaignStatus["FINISHED"] = "finished";
    })(CampaignStatus = FleetOwnerPortalService.CampaignStatus || (FleetOwnerPortalService.CampaignStatus = {}));
    /** Generated from: {@link [CampaignTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/CampaignTypes.ts)} */
    var CampaignType;
    (function (CampaignType) {
        CampaignType["DRIVER"] = "driver";
        CampaignType["REFERRAL"] = "referral";
        CampaignType["CAR"] = "car";
        CampaignType["FLEET"] = "fleet";
    })(CampaignType = FleetOwnerPortalService.CampaignType || (FleetOwnerPortalService.CampaignType = {}));
    /** Generated from: {@link [FleetOrderInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/fleet/FleetOrderInternalAsyncApi.ts)} */
    var CarColor;
    (function (CarColor) {
        CarColor["White"] = "white";
        CarColor["Black"] = "black";
        CarColor["Blue"] = "blue";
        CarColor["Green"] = "green";
        CarColor["Yellow"] = "yellow";
        CarColor["Red"] = "red";
        CarColor["Purple"] = "purple";
        CarColor["Gray"] = "gray";
        CarColor["Brown"] = "brown";
        CarColor["Beige"] = "beige";
        CarColor["Pink"] = "pink";
        CarColor["Orange"] = "orange";
        CarColor["Gold"] = "gold";
        CarColor["Silver"] = "silver";
        CarColor["Bronze"] = "bronze";
        CarColor["Maroon"] = "maroon";
        CarColor["Wine"] = "wine";
        CarColor["WineRed"] = "wineRed";
        CarColor["SkyBlue"] = "skyBlue";
        CarColor["LightBlue"] = "lightBlue";
        CarColor["PearlWhite"] = "pearlWhite";
        CarColor["Pearl"] = "pearl";
        CarColor["DarkGrey"] = "darkGrey";
        CarColor["NavyBlue"] = "navyBlue";
    })(CarColor = FleetOwnerPortalService.CarColor || (FleetOwnerPortalService.CarColor = {}));
    /** Generated from: {@link [FleetCarInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/fleet/FleetCarInternalAsyncApi.ts)} */
    var CarStatus;
    (function (CarStatus) {
        CarStatus["ACTIVE"] = "active";
        CarStatus["BLOCKED"] = "blocked";
        CarStatus["DELETED"] = "deleted";
    })(CarStatus = FleetOwnerPortalService.CarStatus || (FleetOwnerPortalService.CarStatus = {}));
    /** Generated from: {@link [UserConsentsInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/user_consents/UserConsentsInternalAsyncApi.ts)} */
    var Channel;
    (function (Channel) {
        Channel["SMS"] = "sms";
        Channel["PUSH"] = "push";
        Channel["EMAIL"] = "email";
        Channel["APP_INBOX"] = "app_inbox";
        Channel["IN_APP_BANNERS"] = "in_app_banners";
        Channel["WHATSAPP"] = "whatsapp";
        Channel["VOICE_CALLS"] = "voice_calls";
        Channel["PORTAL_NOTIFICATIONS"] = "portal_notifications";
    })(Channel = FleetOwnerPortalService.Channel || (FleetOwnerPortalService.Channel = {}));
    /** Generated from: {@link [CampaignTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/CampaignTypes.ts)} */
    var ChipVariant;
    (function (ChipVariant) {
        ChipVariant["ACTION"] = "action";
        ChipVariant["NEUTRAL"] = "neutral";
    })(ChipVariant = FleetOwnerPortalService.ChipVariant || (FleetOwnerPortalService.ChipVariant = {}));
    /** Generated from: {@link [CampaignTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/CampaignTypes.ts)} */
    var ColumnType;
    (function (ColumnType) {
        ColumnType["ENTITY_NAME"] = "entity_name";
        ColumnType["TEXT"] = "text";
        ColumnType["PERIOD"] = "period";
        ColumnType["BOOLEAN"] = "boolean";
        ColumnType["ICON"] = "icon";
        ColumnType["CHIP"] = "chip";
    })(ColumnType = FleetOwnerPortalService.ColumnType || (FleetOwnerPortalService.ColumnType = {}));
    /** Generated from: {@link [FleetOwnerConsents.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/FleetOwnerConsents.ts)} */
    var Consent;
    (function (Consent) {
        Consent["FLEET_OWNER_PRODUCT_ANNOUNCEMENTS"] = "fleet_owner_product_announcements";
        Consent["FLEET_OWNER_SUPPLY_UPDATES"] = "fleet_owner_supply_updates";
        Consent["FLEET_OWNER_SUPPORT"] = "fleet_owner_support";
        Consent["FLEET_OWNER_CAMPAIGNS_DRIVERS"] = "fleet_owner_campaigns_drivers";
        Consent["FLEET_OWNER_CAMPAIGNS_VEHICLES"] = "fleet_owner_campaigns_vehicles";
        Consent["FLEET_OWNER_CAMPAIGNS_COMPANY"] = "fleet_owner_campaigns_company";
    })(Consent = FleetOwnerPortalService.Consent || (FleetOwnerPortalService.Consent = {}));
    /** Generated from: {@link [Chart.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleetx/api_model/Chart.ts)} */
    var DataPointType;
    (function (DataPointType) {
        DataPointType["CONNECTED"] = "connected";
        DataPointType["DISCRETE"] = "discrete";
    })(DataPointType = FleetOwnerPortalService.DataPointType || (FleetOwnerPortalService.DataPointType = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var DateType;
    (function (DateType) {
        DateType["DATETIME"] = "datetime";
        DateType["SHORT_DATETIME"] = "short_datetime";
    })(DateType = FleetOwnerPortalService.DateType || (FleetOwnerPortalService.DateType = {}));
    /** Generated from: {@link [FleetDocumentsInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/fleet_documents/FleetDocumentsInternalAsyncApi.ts)} */
    var DocumentSource;
    (function (DocumentSource) {
        DocumentSource["ADMIN"] = "admin";
        DocumentSource["DRIVER_PORTAL"] = "driver_portal";
        DocumentSource["FLEET_OWNER_PORTAL"] = "fleet_owner_portal";
        DocumentSource["INSURANCE_API"] = "insurance_api";
        DocumentSource["BEEHIVE"] = "beehive";
    })(DocumentSource = FleetOwnerPortalService.DocumentSource || (FleetOwnerPortalService.DocumentSource = {}));
    /** Generated from: {@link [FleetDocumentsInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/fleet_documents/FleetDocumentsInternalAsyncApi.ts)} */
    var DocumentStatus;
    (function (DocumentStatus) {
        DocumentStatus["CREATED"] = "created";
        DocumentStatus["ERROR"] = "error";
        DocumentStatus["UPLOADED"] = "uploaded";
        DocumentStatus["VERIFIED"] = "verified";
        DocumentStatus["DECLINED"] = "declined";
        DocumentStatus["ARCHIVED"] = "archived";
        DocumentStatus["DELETED"] = "deleted";
    })(DocumentStatus = FleetOwnerPortalService.DocumentStatus || (FleetOwnerPortalService.DocumentStatus = {}));
    /** Generated from: {@link [FleetRegistrationInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/fleet/FleetRegistrationInternalAsyncApi.ts)} */
    var DriverRegistrationLogLastStep;
    (function (DriverRegistrationLogLastStep) {
        DriverRegistrationLogLastStep["STEP1"] = "step_1";
        DriverRegistrationLogLastStep["STEP2"] = "step_2";
        DriverRegistrationLogLastStep["STEP3"] = "step_3";
        DriverRegistrationLogLastStep["STEP4"] = "step_4";
        DriverRegistrationLogLastStep["STEP5"] = "step_5";
        DriverRegistrationLogLastStep["STEP6"] = "step_6";
    })(DriverRegistrationLogLastStep = FleetOwnerPortalService.DriverRegistrationLogLastStep || (FleetOwnerPortalService.DriverRegistrationLogLastStep = {}));
    /** Generated from: {@link [DriverRegistrationPortalInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/driver_registration/DriverRegistrationPortalInternalAsyncApi.ts)} */
    var DriverRegistrationLogStatus;
    (function (DriverRegistrationLogStatus) {
        DriverRegistrationLogStatus["IN_PROGRESS"] = "in_progress";
        DriverRegistrationLogStatus["SUBMITTED"] = "submitted";
        DriverRegistrationLogStatus["ONBOARDING"] = "onboarding";
        DriverRegistrationLogStatus["DECLINED"] = "declined";
        DriverRegistrationLogStatus["DECLINED_SILENTLY"] = "declined_silently";
        DriverRegistrationLogStatus["ACCEPTED"] = "accepted";
        DriverRegistrationLogStatus["DOCUMENTS_NEED_RESUBMISSION"] = "documents_need_resubmission";
        DriverRegistrationLogStatus["DOCUMENTS_RESUBMITTED"] = "documents_resubmitted";
        DriverRegistrationLogStatus["DELETED"] = "deleted";
        DriverRegistrationLogStatus["PENDING_COMPANY_APPROVAL"] = "pending_company_approval";
    })(DriverRegistrationLogStatus = FleetOwnerPortalService.DriverRegistrationLogStatus || (FleetOwnerPortalService.DriverRegistrationLogStatus = {}));
    /** Generated from: {@link [DriverStateChangeEventSubscriberMqApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/order/DriverStateChangeEventSubscriberMqApi.ts)} */
    var DriverState;
    (function (DriverState) {
        DriverState["INACTIVE"] = "inactive";
        DriverState["WAITING_FOR_ORDERS"] = "waiting_orders";
        DriverState["HAS_ORDER"] = "has_order";
        DriverState["BUSY"] = "busy";
    })(DriverState = FleetOwnerPortalService.DriverState || (FleetOwnerPortalService.DriverState = {}));
    /** Generated from: {@link [FleetDriverInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/fleet/FleetDriverInternalAsyncApi.ts)} */
    var DriverStatus;
    (function (DriverStatus) {
        DriverStatus["ACTIVE"] = "active";
        DriverStatus["APPLICATION"] = "application";
        DriverStatus["HIDDEN"] = "hidden";
        DriverStatus["ON_HOLD"] = "on_hold";
        DriverStatus["BLOCKED"] = "blocked";
    })(DriverStatus = FleetOwnerPortalService.DriverStatus || (FleetOwnerPortalService.DriverStatus = {}));
    /** Generated from: {@link [DriverApiColumnService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/service/DriverApiColumnService.ts)} */
    var EngagementDataDriverKey;
    (function (EngagementDataDriverKey) {
        EngagementDataDriverKey["TIER"] = "tier";
        EngagementDataDriverKey["DRIVER"] = "driver";
        EngagementDataDriverKey["EMAIL"] = "email";
        EngagementDataDriverKey["PHONE"] = "phone";
        EngagementDataDriverKey["CASH_RIDES"] = "cash_rides";
        EngagementDataDriverKey["DRIVER_SCORE"] = "driver_score";
        EngagementDataDriverKey["FINISHED_ORDERS"] = "finished_orders";
        EngagementDataDriverKey["TOTAL_ACCEPTANCE_RATE"] = "total_acceptance_rate";
        EngagementDataDriverKey["ACCEPTANCE_RATE_WITHOUT_OPTIONAL_RIDES"] = "acceptance_rate_without_optional_rides";
        EngagementDataDriverKey["ONLINE_HOURS"] = "online_hours";
        EngagementDataDriverKey["ACTIVE_ONLINE_HOURS"] = "active_online_hours";
        EngagementDataDriverKey["WAITING_ONLINE_HOURS"] = "waiting_online_hours";
        EngagementDataDriverKey["ACTIVE_ORDER_TIME"] = "active_order_time";
        EngagementDataDriverKey["UTILISATION_RATE"] = "utilisation_rate";
        EngagementDataDriverKey["FINISH_RATE"] = "finish_rate";
        EngagementDataDriverKey["COMPLETION_RATE"] = "completion_rate";
        EngagementDataDriverKey["AVERAGE_TRIP_DISTANCE"] = "average_trip_distance";
        EngagementDataDriverKey["TOTAL_TRIP_DISTANCE"] = "total_trip_distance";
        EngagementDataDriverKey["AVERAGE_RATING"] = "average_rating";
        EngagementDataDriverKey["DRIVER_IDENTIFIER"] = "driver_identifier";
        EngagementDataDriverKey["INDIVIDUAL_IDENTIFIER"] = "individual_identifier";
    })(EngagementDataDriverKey = FleetOwnerPortalService.EngagementDataDriverKey || (FleetOwnerPortalService.EngagementDataDriverKey = {}));
    /** Generated from: {@link [VehicleService.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/service/VehicleService.ts)} */
    var EngagementDataVehicleKey;
    (function (EngagementDataVehicleKey) {
        EngagementDataVehicleKey["ONLINE_HOURS"] = "online_hours";
        EngagementDataVehicleKey["WAITING_FOR_ORDERS_HOURS"] = "waiting_for_orders_hours";
        EngagementDataVehicleKey["HAS_ORDER_HOURS"] = "has_order_hours";
        EngagementDataVehicleKey["ACCEPTANCE_RATE"] = "acceptance_rate";
        EngagementDataVehicleKey["REQUIRED_ACCEPTANCE_RATE"] = "required_acceptance_rate";
        EngagementDataVehicleKey["FINISHED_ORDERS"] = "finished_orders";
        EngagementDataVehicleKey["RIDES_PER_HOUR"] = "rides_per_hour";
        EngagementDataVehicleKey["GROSS_REVENUE"] = "gross_revenue";
        EngagementDataVehicleKey["NET_EARNINGS"] = "net_earnings";
        EngagementDataVehicleKey["BONUSES"] = "bonuses";
        EngagementDataVehicleKey["EARNINGS_PER_HOUR_GROSS"] = "earnings_per_hour_gross";
        EngagementDataVehicleKey["EARNINGS_PER_HOUR_NET"] = "earnings_per_hour_net";
        EngagementDataVehicleKey["UUID"] = "uuid";
        EngagementDataVehicleKey["WITHHOLDING_TAX"] = "withholding_tax";
        EngagementDataVehicleKey["MODEL"] = "model";
        EngagementDataVehicleKey["REG_NUMBER"] = "reg_number";
    })(EngagementDataVehicleKey = FleetOwnerPortalService.EngagementDataVehicleKey || (FleetOwnerPortalService.EngagementDataVehicleKey = {}));
    /** Generated from: {@link [Types.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/constants/Types.ts)} */
    var EntityPortalStatus;
    (function (EntityPortalStatus) {
        EntityPortalStatus["Active"] = "active";
        EntityPortalStatus["Blocked"] = "blocked";
        EntityPortalStatus["Deactivated"] = "deactivated";
    })(EntityPortalStatus = FleetOwnerPortalService.EntityPortalStatus || (FleetOwnerPortalService.EntityPortalStatus = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var EntityState;
    (function (EntityState) {
        EntityState["DEFAULT"] = "default";
        EntityState["INACTIVE"] = "inactive";
        EntityState["ALERT"] = "alert";
        EntityState["SUCCESS"] = "success";
        EntityState["DANGER"] = "danger";
        EntityState["WARNING"] = "warning";
        EntityState["PENDING"] = "pending";
    })(EntityState = FleetOwnerPortalService.EntityState || (FleetOwnerPortalService.EntityState = {}));
    /** Generated from: {@link [CampaignTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/CampaignTypes.ts)} */
    var EntityType;
    (function (EntityType) {
        EntityType["DRIVER_CAMPAIGN"] = "driver";
        EntityType["REFERRAL_CAMPAIGN"] = "referral";
        EntityType["CAR_CAMPAIGN"] = "car";
        EntityType["FLEET_CAMPAIGN"] = "fleet";
        EntityType["DRIVER"] = "driver_entity";
        EntityType["CAR"] = "car_entity";
    })(EntityType = FleetOwnerPortalService.EntityType || (FleetOwnerPortalService.EntityType = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var EnumKey;
    (function (EnumKey) {
        EnumKey["CREATED_BY_FLEET"] = "created_by_fleet";
        EnumKey["CREATED_BY_RIDER"] = "created_by_rider";
        EnumKey["CASH"] = "cash";
        EnumKey["CARD_TERMINAL"] = "card_terminal";
        EnumKey["IN_APP"] = "in_app";
        EnumKey["BUSINESS"] = "business";
    })(EnumKey = FleetOwnerPortalService.EnumKey || (FleetOwnerPortalService.EnumKey = {}));
    /** Generated from: {@link [Types.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/Types.ts)} */
    var FileFormat;
    (function (FileFormat) {
        FileFormat["CSV"] = "csv";
        FileFormat["PDF"] = "pdf";
    })(FileFormat = FleetOwnerPortalService.FileFormat || (FleetOwnerPortalService.FileFormat = {}));
    /** Generated from: {@link [FormOfWork.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/driver/constants/FormOfWork.ts)} */
    var FormOfWork;
    (function (FormOfWork) {
        FormOfWork["LICENSE_OWNER"] = "license_owner";
        FormOfWork["EMPLOYEE_OF_A_FLEET"] = "employee_of_a_fleet";
    })(FormOfWork = FleetOwnerPortalService.FormOfWork || (FleetOwnerPortalService.FormOfWork = {}));
    /** Generated from: {@link [CampaignTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/CampaignTypes.ts)} */
    var KalepIconName;
    (function (KalepIconName) {
        KalepIconName["USER"] = "User";
        KalepIconName["OFFER"] = "Offer";
        KalepIconName["CASH"] = "Cash";
        KalepIconName["SURGE"] = "Surge";
        KalepIconName["PERCENT"] = "Percent";
        KalepIconName["VEHICLE"] = "Vehicle";
        KalepIconName["SANDGLASS"] = "Sandglass";
        KalepIconName["COMPANY"] = "Company";
    })(KalepIconName = FleetOwnerPortalService.KalepIconName || (FleetOwnerPortalService.KalepIconName = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var ListColumnType;
    (function (ListColumnType) {
        ListColumnType["STRING"] = "string";
        ListColumnType["DURATION"] = "duration";
        ListColumnType["NUMBER"] = "number";
        ListColumnType["REFERENCE_V2"] = "reference_v2";
        ListColumnType["STATE"] = "state";
        ListColumnType["DATE"] = "date";
        ListColumnType["BOOLEAN"] = "boolean";
        ListColumnType["STATUS"] = "status";
        ListColumnType["ENUM"] = "enum";
        ListColumnType["CUSTOM"] = "custom";
    })(ListColumnType = FleetOwnerPortalService.ListColumnType || (FleetOwnerPortalService.ListColumnType = {}));
    /** Generated from: {@link [DriverBlockingGatewayInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/driver_blocking_gateway/DriverBlockingGatewayInternalAsyncApi.ts)} */
    var ManualBlockReason;
    (function (ManualBlockReason) {
        ManualBlockReason["CUSTOM"] = "custom";
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ManualBlockReason["TEMP_MANUAL_STAT_BLOCKING_FR"] = "temp_manual_stat_blocking_fr";
    })(ManualBlockReason = FleetOwnerPortalService.ManualBlockReason || (FleetOwnerPortalService.ManualBlockReason = {}));
    /** Generated from: {@link [DriverBlockHelper.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/block/DriverBlockHelper.ts)} */
    var NonScheduledBlockReason;
    (function (NonScheduledBlockReason) {
        NonScheduledBlockReason["UNKNOWN"] = "unknown";
    })(NonScheduledBlockReason = FleetOwnerPortalService.NonScheduledBlockReason || (FleetOwnerPortalService.NonScheduledBlockReason = {}));
    /** Generated from: {@link [Base.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleetx/api_model/Base.ts)} */
    var NumberTrendBehavior;
    (function (NumberTrendBehavior) {
        NumberTrendBehavior["POSITIVE_VALUE_AS_IMPROVEMENT"] = "positive_value_as_improvement";
        NumberTrendBehavior["NEGATIVE_VALUE_AS_IMPROVEMENT"] = "negative_value_as_improvement";
    })(NumberTrendBehavior = FleetOwnerPortalService.NumberTrendBehavior || (FleetOwnerPortalService.NumberTrendBehavior = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var NumberType;
    (function (NumberType) {
        NumberType["INTEGER"] = "integer";
        NumberType["DECIMAL"] = "decimal";
    })(NumberType = FleetOwnerPortalService.NumberType || (FleetOwnerPortalService.NumberType = {}));
    /**
     * Consider replacing with a search-specific enum.
     * Not all states are used here.
     * search mostly cares simply if an order is active or not
     * Seems to be exposed in a fleet-owner-portal API.
     */
    /** Generated from: {@link [SearchWorkerInternalAsyncShardedApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/search_worker/SearchWorkerInternalAsyncShardedApi.ts)} */
    var OrderTryState;
    (function (OrderTryState) {
        OrderTryState["DRIVER_BOOKING"] = "driver_booking";
        OrderTryState["WAITING_DRIVER_CONFIRMATION"] = "waiting_driver_confirmation";
        OrderTryState["CLIENT_CANCELLED"] = "client_cancelled";
        OrderTryState["DRIVER_DID_NOT_RESPOND"] = "driver_did_not_respond";
        OrderTryState["DRIVER_REJECTED"] = "driver_rejected";
        OrderTryState["DRIVER_ACCEPTED"] = "driver_accepted";
        OrderTryState["DRIVER_ARRIVED_TO_CLIENT"] = "driver_arrived_to_client";
        OrderTryState["CLIENT_DID_NOT_SHOW"] = "client_did_not_show";
        OrderTryState["DRIVING_WITH_CLIENT"] = "driving_with_client";
        OrderTryState["ARRIVED_TO_DESTINATION"] = "arrived_to_destination";
        OrderTryState["FINISHED"] = "finished";
        OrderTryState["PAYMENT_BOOKING_FAILED"] = "payment_booking_failed";
        OrderTryState["NO_TAXI_PROVIDED"] = "no_taxi_provided";
    })(OrderTryState = FleetOwnerPortalService.OrderTryState || (FleetOwnerPortalService.OrderTryState = {}));
    /** Generated from: {@link [FleetDriverInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/fleet/FleetDriverInternalAsyncApi.ts)} */
    var PartnerStatus;
    (function (PartnerStatus) {
        PartnerStatus["ACTIVE"] = "active";
        PartnerStatus["BLOCKED"] = "blocked";
        PartnerStatus["DELETED"] = "deleted";
    })(PartnerStatus = FleetOwnerPortalService.PartnerStatus || (FleetOwnerPortalService.PartnerStatus = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var ReferenceType;
    (function (ReferenceType) {
        ReferenceType["VEHICLE"] = "vehicle";
        ReferenceType["DRIVER"] = "driver";
        ReferenceType["VEHICLE_LISTING_APPLICATION"] = "vehicle_listing_application";
    })(ReferenceType = FleetOwnerPortalService.ReferenceType || (FleetOwnerPortalService.ReferenceType = {}));
    /** Generated from: {@link [DriverBlockingGatewayInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/driver_blocking_gateway/DriverBlockingGatewayInternalAsyncApi.ts)} */
    var ScheduledBlockReason;
    (function (ScheduledBlockReason) {
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["INVOICE_NOT_PAID"] = "invoice_not_paid";
        ScheduledBlockReason["LOW_REJECTED_OR_DID_NOT_RESPOND_PERCENTAGE"] = "low_rejected_or_did_not_respond_percentage";
        ScheduledBlockReason["LOW_DRIVER_CANCELLED_PERCENTAGE"] = "low_driver_cancelled_percentage";
        ScheduledBlockReason["LOW_CLIENT_DID_NOT_SHOW_PERCENTAGE"] = "low_client_did_not_show_percentage";
        ScheduledBlockReason["LOW_CLIENT_CANCELLED_PERCENTAGE"] = "low_client_cancelled_percentage";
        ScheduledBlockReason["LOW_AVERAGE_RATING_PERCENTAGE"] = "low_avg_rating_percentage";
        ScheduledBlockReason["TOO_MUCH_BEEN_ONLINE"] = "too_much_been_online";
        ScheduledBlockReason["EXPIRED_DOCUMENTS"] = "expired_documents";
        ScheduledBlockReason["EXTERNAL_CHECK_FAILED"] = "external_check_failed";
        ScheduledBlockReason["FAILED_DRIVER_AUDIT"] = "failed_driver_audit";
        ScheduledBlockReason["IRREGULAR_SUSPICIOUS_ACTIVITIES"] = "irregular_suspicious_activities";
        ScheduledBlockReason["CAR_APPLICATION_ADDED"] = "car_application_added";
        ScheduledBlockReason["INCORRECT_PRICING"] = "incorrect_pricing";
        ScheduledBlockReason["CUSTOMER_COMPLAINTS"] = "customer_complaints";
        ScheduledBlockReason["IMPERSONATING_ANOTHER_DRIVER"] = "impersonating_another_driver";
        ScheduledBlockReason["HIGH_PRIORITY_CASES"] = "high_priority_cases";
        ScheduledBlockReason["DOCUMENT_EXPIRED"] = "document_expired";
        ScheduledBlockReason["POSSIBLE_NEW_CAR_APPLICATION"] = "possible_new_car_application";
        /**
         * @deprecated - not used since 2021. It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["DRIVER_BEHAVIOUR_SYSTEM"] = "driver_behaviour_system";
        ScheduledBlockReason["EXTERNAL_AUTHORITY_PENDING"] = "external_authority_pending";
        ScheduledBlockReason["EXTERNAL_AUTHORITY_REJECTED"] = "external_authority_rejected";
        ScheduledBlockReason["EXTERNAL_AIRWALLEX_PENDING"] = "external_airwallex_pending";
        ScheduledBlockReason["EXTERNAL_AIRWALLEX_REJECTED"] = "external_airwallex_rejected";
        ScheduledBlockReason["IDENTIFICATION_VERIFICATION_FAILED"] = "identification_verification_failed";
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["IDENTIFICATION_AUTHENTICATION_FAILED"] = "identification_authentication_failed";
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["UNDER_INVESTIGATION"] = "under_investigation";
        ScheduledBlockReason["NO_RESPONSE_LOST_PROPERTY"] = "no_response_lost_property";
        ScheduledBlockReason["DOCUMENT_QUALITY"] = "document_quality";
        ScheduledBlockReason["CAR_APPLICATION_ADDED_MANUAL"] = "car_application_added_manual";
        ScheduledBlockReason["BILLING_DETAILS_VALIDATION_FAILED"] = "billing_details_validation_failed";
        ScheduledBlockReason["NO_VALID_TAX_REPORTING_CREDENTIALS"] = "no_valid_tax_reporting_credentials";
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["OTHER_DRIVER_ACTION_REQUIRED"] = "other_driver_action_required";
        ScheduledBlockReason["SUSPICIOUS_ACTIVITY_OR_FRAUDULENT_BEHAVIOUR"] = "suspicious_activity_or_fraudulent_behaviour";
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["EXTERNAL_CHECK_PENDING"] = "external_check_pending";
        ScheduledBlockReason["EXTERNAL_CHECK_DRIVER_LICENSE_FAILED"] = "external_check_driver_license_failed";
        ScheduledBlockReason["DRIVER_BEHAVIOUR_BLOCK_RETRAINING"] = "driver_behaviour_block_retraining";
        ScheduledBlockReason["DRIVER_CONTEXTUAL_GUIDANCE"] = "driver_contextual_guidance";
        ScheduledBlockReason["DRIVER_CONTEXTUAL_BLOCK"] = "driver_contextual_block";
        ScheduledBlockReason["DRIVER_BEHAVIOUR_BLOCK_REVIEW_NEEDED"] = "driver_behaviour_block_review_needed";
        ScheduledBlockReason["DRIVER_BEHAVIOUR_BLOCK_LONG_SUSPENSION"] = "driver_behaviour_block_long_suspension";
        ScheduledBlockReason["DOCUMENT_VEHICLE_INSURANCE_VALIDITY_GAP"] = "document_vehicle_insurance_validity_gap";
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["COVID_POSITIVE"] = "covid_positive";
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["EXCESSIVE_COUGHING"] = "excessive_coughing";
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["MISUSING_COVID_RELATED_CANCELLATION_REASONS"] = "misusing_covid_related_cancellation_reasons";
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["NOT_WEARING_FACE_MASK"] = "not_wearing_face_mask";
        ScheduledBlockReason["DOCUMENT_UPLOAD_REQUESTED"] = "document_upload_requested";
        ScheduledBlockReason["VEHICLE_INSURANCE_MISSING_IN_MID"] = "vehicle_insurance_missing_in_mid";
        ScheduledBlockReason["CUSTOMER_SAFETY_SUPPORT"] = "customer_safety_support";
        ScheduledBlockReason["DRIVER_WRONG_CONTACT_DETAILS"] = "driver_wrong_contact_details";
        /**
         * @deprecated It's not longer possible to add a block with this reason.
         */
        ScheduledBlockReason["DRIVER_DID_NOT_RESPOND_LOST_ITEM_TICKET"] = "driver_did_not_respond_lost_item_ticket";
        ScheduledBlockReason["DRIVER_DID_NOT_DELIVER_PARCEL"] = "driver_did_not_deliver_parcel";
        ScheduledBlockReason["INCORRECT_VEHICLE_SIGNAGE"] = "incorrect_vehicle_signage";
        ScheduledBlockReason["LOW_ACCEPTANCE_RATE"] = "low_acceptance_rate";
        ScheduledBlockReason["DRIVER_WAS_NOT_WEARING_A_MASK"] = "driver_was_not_wearing_a_mask";
        ScheduledBlockReason["LICENCE_SUSPENDED_BY_LICENSING_AUTHORITY"] = "licence_suspended_by_licensing_authority";
        ScheduledBlockReason["DOCUMENT_MISSING"] = "document_missing";
        ScheduledBlockReason["IDENTIFICATION_REQUIRED"] = "identification_required";
        ScheduledBlockReason["FORM_OF_WORK_MISSING"] = "form_of_work_missing";
        ScheduledBlockReason["LANGUAGE_COMPLIANCE"] = "language_compliance";
        ScheduledBlockReason["DRIVER_DEACTIVATION_BY_FLEET_OWNER"] = "driver_deactivation_by_fleet_owner";
        ScheduledBlockReason["FLEET_COMPANY_BLOCKED"] = "fleet_company_blocked";
        ScheduledBlockReason["PHISHING_ATTEMPT"] = "phishing_attempt";
        ScheduledBlockReason["DOCUMENTS_PENDING_REVIEW"] = "documents_pending_review";
        ScheduledBlockReason["REPORTED_OFFLINE_TRIPS"] = "reported_offline_trips";
        ScheduledBlockReason["PENDING_REONBOARDING"] = "pending_reonboarding";
        ScheduledBlockReason["ONSITE_VERIFICATION_REQUIRED"] = "onsite_verification_required";
        ScheduledBlockReason["UNUSUAL_TRIP_ACTIVITY"] = "unusual_trip_activity";
        ScheduledBlockReason["OUTSTANDING_PAYMENT_TO_FLEET"] = "outstanding_payment_to_fleet";
        ScheduledBlockReason["MANUAL_EXTERNAL_AUTHORITY_PENDING"] = "manual_external_authority_pending";
        ScheduledBlockReason["SAFETY_INCIDENT_INVESTIGATION"] = "safety_incident_investigation";
    })(ScheduledBlockReason = FleetOwnerPortalService.ScheduledBlockReason || (FleetOwnerPortalService.ScheduledBlockReason = {}));
    /** Generated from: {@link [FleetPortalController.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/src/rides/fleet/fleet_owner_portal/main/controller/FleetPortalController.ts)} */
    var SortingDirection;
    (function (SortingDirection) {
        SortingDirection["DESC"] = "desc";
        SortingDirection["ASC"] = "asc";
    })(SortingDirection = FleetOwnerPortalService.SortingDirection || (FleetOwnerPortalService.SortingDirection = {}));
    /** Generated from: {@link [CampaignTypes.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/constants/CampaignTypes.ts)} */
    var TextSize;
    (function (TextSize) {
        TextSize["REGULAR"] = "regular";
        TextSize["LARGE"] = "large";
    })(TextSize = FleetOwnerPortalService.TextSize || (FleetOwnerPortalService.TextSize = {}));
    /** Generated from: {@link [DriverLoyaltyInternalAsyncApi.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/asyncApi/driver_loyalty/DriverLoyaltyInternalAsyncApi.ts)} */
    var TierStatus;
    (function (TierStatus) {
        TierStatus["ACTIVE"] = "ACTIVE";
        TierStatus["INACTVIE"] = "INACTIVE";
    })(TierStatus = FleetOwnerPortalService.TierStatus || (FleetOwnerPortalService.TierStatus = {}));
    /** Generated from: {@link [ApiDrivenTables.ts](https://github.com/bolteu/bolt-server/blob/c20fc1eb512d23946c588511b2e9dfa349b78b80/common/fleet/utils/ApiDrivenTables.ts)} */
    var TrendBehavior;
    (function (TrendBehavior) {
        TrendBehavior["POSITIVE_IS_SUCCESS"] = "positive_as_success";
        TrendBehavior["POSITIVE_IS_DANGER"] = "positive_as_danger";
    })(TrendBehavior = FleetOwnerPortalService.TrendBehavior || (FleetOwnerPortalService.TrendBehavior = {}));
})(FleetOwnerPortalService || (FleetOwnerPortalService = {}));
